import { useState, useEffect } from "react";
import { POST_GET_TABLE_BOOKING_HISTORY } from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import { Link, useHistory } from "react-router-dom";

import UserNameHeader from '../../component/UserNameHeader';
import UserMenu from '../../component/UserMenu';

export default function Home() {
    let history = useHistory();
    const [Page, setPage] = useState(0);
    const [TableBookingHistory, setTableBookingHistory] = useState({});
    const [ShowLoadMore, setShowLoadMore] = useState(false);

    useEffect(() => {
        async function get_detaile() {
            await get_order_history();
        }
        get_detaile();
    }, []);

    const get_order_history = async (load_more = 0) => {
        var page = (Page + load_more)
        setPage(page);
        var res_data = await post(POST_GET_TABLE_BOOKING_HISTORY, { page: page,type : 'Table Booking' });
        if (res_data.status) {
            if (load_more) {
                setTableBookingHistory([...TableBookingHistory, ...res_data.data.order_list]);
            } else {
                setTableBookingHistory(res_data.data.order_list);
            }
            setShowLoadMore(res_data.data.load_more);
        } else {
            toast.error(res_data.message);
            history.push("/");
        }
    }
    const load_more = async () => {
		await get_order_history(1);
	}


    return (<>
        <UserNameHeader />
        <div class="container">
            <div class="order_his">
                <UserMenu />

                {TableBookingHistory.length > 0 && Object.entries(TableBookingHistory).map(([key, order]) => {
                    return (<div class="order_row" key={key}>
                        <ul>
                            <li><span><b>Booking No: </b></span> <span><b>#{order.booking_no} </b></span></li>
                            <li><span>Preferred Date:  </span> <span>{order.order_data} </span></li>
                            <li><span>Start Time:  </span> <span>{order.time} - {order.date}</span></li>
                            <li><span>Status: </span> 
                                {order.status === 'Pending' && <span class="btn_panding">{order.status}</span>}
                                {order.status === 'Confirmed' && <span class="btn_confirmed">{order.status}</span>}
                                {order.status === 'Complete' && <span class="btn_complete">{order.status}</span>}
                                {order.status === 'Cancelled' && <span class="btn_canceld">{order.status}</span>}
                            </li>
                            <li><span><b>Number Of Guests:</b> </span> <span><b>${order.number_of_people}</b></span></li>
                            <li><Link to={`/table-booking-history/detail/${order.booking_no}`}>View Details</Link></li>
                        </ul>
                    </div>)
                })}
                {TableBookingHistory.length <= 0 && <div className="text-center pb-5 pt-5">
                    <p>No any booking</p>
                </div>}
                {ShowLoadMore && <div className="col-sm-12 text-center mt-5">
						<button type="button" onClick={load_more} className="btn btn-success btn-radius pl-3 pr-3 mr-2">Load More ...</button>
					</div>}
            </div>
        </div>

    </>)
}
